import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { UpdateUserFullName } from "src/app/features/users/state/users.actions";
import { withFlag } from "src/app/shared/states/with-flag.operator";
import { UserProfileService } from "../services/user-profile.service";
import { ChangePassword, LoadMyProfile, ResetSuccess, UpdateProfile } from "./user-profile.actions";
import { UserProfileStateModel } from "./user-profile.model";

@State<UserProfileStateModel>({
  name: "userProfile",
  defaults: {
    loading: false,
    saving: false,
    changingPassword: false,
    success: false
  }
})
@Injectable()
export class UserProfileState {

  constructor(
    private userProfileService: UserProfileService
  ) {}

  @Selector() static loading(state: UserProfileStateModel) { return state.loading; }
  @Selector() static saving(state: UserProfileStateModel) { return state.saving; }
  @Selector() static changingPassword(state: UserProfileStateModel) { return state.changingPassword; }
  @Selector() static success(state: UserProfileStateModel) { return state.success; }
  @Selector() static user(state: UserProfileStateModel) { return state.user; }

  @Action(LoadMyProfile)
  loadMyProfile(ctx: StateContext<UserProfileStateModel>) {
    return this.userProfileService.getMyProfile().pipe(
      withFlag(ctx, "loading", {
        onSuccess: (response) => ctx.patchState({ user: response })
      })
    );
  }

  @Action(UpdateProfile)
  updateProfile(ctx: StateContext<UserProfileStateModel>, action: UpdateProfile) {
    ctx.patchState({ success: false });

    return this.userProfileService.updateMyProfile(action.payload).pipe(
      withFlag(ctx, "saving", {
        onSuccess: () => {
          ctx.dispatch(new UpdateUserFullName(`${action.payload.firstName} ${action.payload.lastName}`));
          ctx.patchState({ success: true });
        },
        onError: () => ctx.patchState({ success: false })
      })
    );
  }

  @Action(ResetSuccess)
  resetSuccess(ctx: StateContext<UserProfileStateModel>) {
    ctx.patchState({
      success: false
    });
  }

  @Action(ChangePassword)
  changePassword(ctx: StateContext<UserProfileStateModel>, action: ChangePassword) {
    return this.userProfileService.changePassword(action.payload).pipe(
      withFlag(ctx, "changingPassword")
    );
  }
}
